
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/host-tombo",
      function () {
        return require("private-next-pages/host-tombo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/host-tombo"])
      });
    }
  